import * as React from 'react';
import * as classes from './vendor-info.scss';
import { OptionsViewModel } from '@models/common.models';
import { DynamicSelectLookup } from '@common/components/dynamic-select-lookup/dynamic-select-lookup.component';
import { EditLink } from '../../../common/components/wizard/_components/wizard-edit-link.component';
import { Link } from 'react-router-dom';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { BusinessHours } from '@models/Vendor';

export interface VendorInfoGeneralComponentProperties {
  readonly jump?: (step: number) => void | undefined;
  readonly companyName: string;
  readonly id: number;
  readonly emailAddress: string;

  readonly dbaName: string;
  readonly vendorGroup: OptionsViewModel;
  readonly vendorGroupOptions?: OptionsViewModel[];
  readonly businessPhone: string;
  readonly businessFax: string;
  readonly afterHoursPhone: string;

  readonly ownerName: string;
  readonly managerName: string;

  readonly isTab?: boolean;

  readonly weekdayHours?: BusinessHours;
  readonly saturdayHours?: BusinessHours;
  readonly sundayHours?: BusinessHours;
  readonly holidayHours?: BusinessHours;
}

export class VendorInfoGeneralComponent extends React.Component<VendorInfoGeneralComponentProperties> {
  render() {
    return (
      <section className={!this.props.isTab ? [classes.summary, 'row col-md-12'].join(' ') : classes.summary}>
        <div className={!this.props.isTab ? [classes.summaryCardRight, 'col-md-12'].join(' ') : classes.summary}>
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-9">
                <h4>
                  General Info{' '}
                  {this.props.isTab && (
                    <Link to={getRoute(RouteDefinitions.vendor.Edit, { id: +this.props.id })}>Edit</Link>
                  )}
                </h4>
              </div>
              <div className="col-xs-3 text-right">
                <h4>{!this.props.id ? <EditLink step={0} jump={this.props.jump} /> : ''}</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-lg-2">
                <label>Company Name</label>
                <h5>{this.props.companyName || '--'}</h5>
              </div>
              <div className="ccol-md-4 col-lg-2">
                <label>Vendor ID</label>
                <h5>{this.props.id || '--'}</h5>
              </div>
              <div className="col-md-4 col-lg-2">
                <label>Vendor's Email Address</label>
                <p className="mt-10 pt-5">{this.props.emailAddress || '--'}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label>DBA Name</label>
                <h5>{this.props.dbaName || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Vendor Group</label>
                <h5>
                  {this.props.vendorGroup ? (
                    <DynamicSelectLookup optVM={this.props.vendorGroup} opts={this.props.vendorGroupOptions} />
                  ) : (
                    '--'
                  )}
                </h5>
              </div>
              <div className="col-md-2">
                <label>Business Phone</label>
                <h5>{this.props.businessPhone || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Business Fax</label>
                <h5>{this.props.businessFax || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>After Hours</label>
                <h5>{this.props.afterHoursPhone || '--'}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Owner</label>
                <h5>{this.props.ownerName || '--'}</h5>
              </div>
              <div className="col-md-6">
                <label>Manager</label>
                <h5>{this.props.managerName || '--'}</h5>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <label>Business Hours</label>
                {(this.props.weekdayHours &&
                  this.props.weekdayHours.startHour && (
                    <h5>
                      Weekday {this.props.weekdayHours.startHour}:{this.props.weekdayHours.startMinute}{' '}
                      {this.props.weekdayHours.startPeriod && this.props.weekdayHours.startPeriod} -{' '}
                      {this.props.weekdayHours.endHour}:{this.props.weekdayHours.endMinute}{' '}
                      {this.props.weekdayHours.endPeriod}
                    </h5>
                  )) || <h5>--</h5>}
                {this.props.saturdayHours &&
                  this.props.saturdayHours.startHour && (
                    <h5>
                      Saturday {this.props.saturdayHours.startHour}:{this.props.saturdayHours.startMinute}{' '}
                      {this.props.saturdayHours.startPeriod && this.props.saturdayHours.startPeriod} -{' '}
                      {this.props.saturdayHours.endHour}:{this.props.saturdayHours.endMinute}{' '}
                      {this.props.saturdayHours.endPeriod}
                    </h5>
                  )}
                {this.props.sundayHours &&
                  this.props.sundayHours.startHour && (
                    <h5>
                      Sunday {this.props.sundayHours.startHour}:{this.props.sundayHours.startMinute}{' '}
                      {this.props.sundayHours.startPeriod && this.props.sundayHours.startPeriod} -{' '}
                      {this.props.sundayHours.endHour}:{this.props.sundayHours.endMinute}{' '}
                      {this.props.sundayHours.endPeriod}
                    </h5>
                  )}
                {this.props.holidayHours &&
                  this.props.holidayHours.startHour && (
                    <h5>
                      Holiday {this.props.holidayHours.startHour}:{this.props.holidayHours.startMinute}{' '}
                      {this.props.holidayHours.startPeriod && this.props.holidayHours.startPeriod} -{' '}
                      {this.props.holidayHours.endHour}:{this.props.holidayHours.endMinute}{' '}
                      {this.props.holidayHours.endPeriod}
                    </h5>
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info-general.component.tsx